import axios from './BaseService';

const PLANS_URL = `${
    process.env.REACT_APP_API_URL || window._env_?.REACT_APP_API_URL
}/plans/`;

export async function getPlans(page) {
    const url = `${PLANS_URL}?page=${page}`;

    const response = await axios.get(url);
    return response.data; //{count, rows}
}

export async function getAllPlans() {
    const response = await axios.get(`${PLANS_URL}all`);
    return response.data;
}

export async function getActivePlans() {
    const response = await axios.get(`${PLANS_URL}active`);
    return response.data;
}

export async function savePlan(id, newPlan) {
    let response;
    if (id) response = await axios.patch(`${PLANS_URL}${id}`, newPlan);
    else response = await axios.post(PLANS_URL, newPlan);
    return response.data;
}

export async function deletePlan(id) {
    const response = await axios.delete(`${PLANS_URL}${id}`);
    return response.data;
}

export async function startPlan(id) {
    const response = await axios.patch(`${PLANS_URL}${id}`, { isActive: true });
    return response.data;
}

export async function stopPlan(id) {
    const response = await axios.patch(`${PLANS_URL}${id}`, {
        isActive: false,
    });
    return response.data;
}
